import { Textarea } from '../../../ui/textarea';
import React, { useState } from 'react';
import { useTranslate } from 'sbx-crm-menu-ui';

type Props = {
    sendMessage: (message: string) => void
}

const ChatInputComponent = ({ sendMessage }: Props) => {
    const [text, setText] = useState('');
    const { t } = useTranslate('common');

    return (
        <div className="flex flex-col  bg-white drop-shadow-lg  transition ease-in rounded-xl  p-1">
            <Textarea
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        sendMessage(text);
                        setText('');
                    }
                }}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder={`${t('type_your_message')}`}
                className="flex-1 resize-none rounded-2xl border-0 focus-visible:ring-transparent
                     focus:ring-0 text-sm"
            />
        </div>
    );
};

export default ChatInputComponent;